<template>
    <div>
        <div class="chat-body" ref="chatBody">
            <div
                v-for="(msg, index) in messages"
                :key="index"
                :class="[
                    'message-row',
                    msg.commentedBy.userType !== 'CUSTOMER'
                        ? 'seller'
                        : 'customer',
                ]"
            >
                <div class="avatar"><i class="fa fa-user"> </i></div>
                <div class="message">{{ msg.comment }}</div>
            </div>
        </div>

        <div class="chat-input">
            <input
                v-model="newMessage"
                @keyup.enter="sendMessage"
                placeholder="Write a message..."
            />
            <button @click="sendMessage">➤</button>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
    components: {},
    props: {
        reviewDetail: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            newMessage: "",
            messages: [],
        };
    },
    computed: {
        ...mapState({
            reviewList: (state) => state.partner.reviewList,
        }),
        ...mapGetters({
            partnerAllData: "partner/GetPartnerData",
        }),
        updatedRatingReviewData() {
            let ratingReviewList = this.reviewList.flatMap((ratingData) => {
                const { ratings, ...rest } = ratingData;
                return (ratings || []).map((rating) => ({
                    ...rating,
                    ...rest,
                    rateingId: rating._id,
                }));
            });
            return ratingReviewList.find(
                (item) => item.rateingId === this.reviewDetail.rateingId,
            );
        },
    },
    methods: {
        async sendMessage() {
            if (this.newMessage.trim()) {
                let payload = {
                    userId: this.reviewDetail.rateingId,
                    load: {
                        category: "Conversation",
                        comment: this.newMessage.trim(),
                        commentedBy: {
                            name: this.partnerAllData?.authentication?.userName
                                ? this.partnerAllData.authentication.userName
                                : this.$currentUserData.userName,
                            userType: "SELLER",
                            time: new Date().toISOString(),
                        },
                    },
                };
                await this.$store.dispatch(
                    "partner/handleReplyToCustomer",
                    payload,
                );
                await this.$store.dispatch(
                    "partner/getReviewListAction",
                    this.$route.params.id,
                );
                this.addUserComment(this.updatedRatingReviewData);
                this.scrollToBottom();
                this.newMessage = "";
            }
        },

        addUserComment(val) {
            if (val.comments) {
                this.messages = [...val.comments];
            }
            const comment = val.feedbackComment || "";
            if (comment) {
                this.messages.unshift({
                    category: "Conversation",
                    comment: comment,
                    commentedBy: {
                        name:
                            val.givenBy.name.first +
                            " " +
                            val.givenBy.name.last,
                        time: val.createdAt,
                        userType: val.givenBy.userType,
                        _id: val.givenBy.userId,
                    },
                    _id: "",
                });
            }
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const chatBody = this.$refs.chatBody;
                if (chatBody) {
                    chatBody.scrollTop = chatBody.scrollHeight;
                }
            });
        },
    },
    mounted() {
        this.messages = [];
        this.addUserComment(this.reviewDetail);
    },
};
</script>

<style scoped>
.chat-body {
    background-color: #fff;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
    min-height: 200px;
    max-height: 250px;
    overflow-y: auto;
    padding: 10px;
}

.message-row {
    display: flex;
    align-items: flex-end;
}

.message-row.customer .message {
    background-color: #064b1f;
    color: white;
    padding: 10px 14px;
    border-radius: 0px 12px 12px 12px;
    margin-left: 10px;
    max-width: 60%;
}

.message-row.seller {
    flex-direction: row-reverse;
}

.message-row.seller .message {
    background-color: #f2f2f2;
    color: black;
    padding: 10px 14px;
    border-radius: 12px 0px 12px 12px;
    margin-right: 10px;
    max-width: 60%;
}

.avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.chat-input {
    display: flex;
    padding: 10px;
    border-top: 1px solid #ccc;
}

.chat-input input {
    background-color: #dcdcdc;
    flex: 1;
    border-radius: 6px;
    outline: none;
    padding: 10px;
    margin-right: 10px;
    font-size: 14px;
    border: none;
}

.chat-input button {
    color: black;
    border: 1px solid #064b1f;
    border-radius: 26px;
    padding: 0 13px;
    font-size: 14px;
    cursor: pointer;
    background: white;
}
</style>
